import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SecurityLanding.css';

function EcommerceLanding() {
  const navigate = useNavigate();

  const handleBackToSession = () => {
    // Go back to the previous page (the session)
    navigate(-1);
  };

  const handleCartClick = () => {
    // Clicking cart also returns to session
    navigate(-1);
  };

  const handleAccountClick = () => {
    // Clicking account also returns to session
    navigate(-1);
  };

  return (
    <div className="ecom-landing">
      {/* Navigation Bar */}
      <div className="ecom-navbar">
        <div className="nav-container">
          <div className="nav-brand">
            <span className="brand-icon">🏪</span>
            <span className="brand-name">TechHub Store</span>
          </div>
          <div className="nav-search">
            <input type="text" placeholder="Search products..." />
            <button>Search</button>
          </div>
          <div className="nav-actions">
            <button className="nav-btn" onClick={handleCartClick}>Cart (0)</button>
            <button className="nav-btn" onClick={handleAccountClick}>Account</button>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="ecom-hero">
        <div className="hero-content">
          <h1>Latest Tech Products</h1>
          <p>Discover cutting-edge technology at unbeatable prices. Shop now and save big!</p>
          <button className="hero-cta">Shop Now</button>
        </div>
        <div className="hero-banner">
          <div className="banner-item">📱 New Smartphones</div>
          <div className="banner-item">💻 Premium Laptops</div>
        </div>
      </div>

      {/* Promo Banner */}
      <div className="promo-banner">
        <div className="promo-item">
          <div style={{ fontSize: '1.5rem' }}>📦</div>
          <div>
            <h3>Free Shipping</h3>
            <p>On orders over $50</p>
          </div>
        </div>
        <div className="promo-item">
          <div style={{ fontSize: '1.5rem' }}>💳</div>
          <div>
            <h3>Easy Returns</h3>
            <p>30-day return policy</p>
          </div>
        </div>
        <div className="promo-item">
          <div style={{ fontSize: '1.5rem' }}>🛡️</div>
          <div>
            <h3>Secure Payment</h3>
            <p>100% secure checkout</p>
          </div>
        </div>
        <div className="promo-item">
          <div style={{ fontSize: '1.5rem' }}>🚀</div>
          <div>
            <h3>Fast Delivery</h3>
            <p>Delivered in 2-3 days</p>
          </div>
        </div>
      </div>

      {/* Featured Products */}
      <div className="featured-section">
        <div className="section-header">
          <h2>Featured Products</h2>
          <p>Check out our best-selling items</p>
        </div>
        <div className="products-grid">
          <div className="product-card">
            <div className="product-image">📱</div>
            <div className="product-info">
              <h3>Latest Smartphones</h3>
              <div className="product-rating">
                <span className="stars">★★★★★</span>
                <span className="reviews">(324 reviews)</span>
              </div>
              <div className="product-footer">
                <span className="product-price">$599</span>
                <button className="add-to-cart">Add Cart</button>
              </div>
            </div>
          </div>

          <div className="product-card">
            <div className="product-image">💻</div>
            <div className="product-info">
              <h3>Premium Laptops</h3>
              <div className="product-rating">
                <span className="stars">★★★★★</span>
                <span className="reviews">(256 reviews)</span>
              </div>
              <div className="product-footer">
                <span className="product-price">$999</span>
                <button className="add-to-cart">Add Cart</button>
              </div>
            </div>
          </div>

          <div className="product-card">
            <div className="product-image">⌚</div>
            <div className="product-info">
              <h3>Smart Watches</h3>
              <div className="product-rating">
                <span className="stars">★★★★★</span>
                <span className="reviews">(189 reviews)</span>
              </div>
              <div className="product-footer">
                <span className="product-price">$199</span>
                <button className="add-to-cart">Add Cart</button>
              </div>
            </div>
          </div>

          <div className="product-card">
            <div className="product-image">🎧</div>
            <div className="product-info">
              <h3>Audio Accessories</h3>
              <div className="product-rating">
                <span className="stars">★★★★☆</span>
                <span className="reviews">(145 reviews)</span>
              </div>
              <div className="product-footer">
                <span className="product-price">$79</span>
                <button className="add-to-cart">Add Cart</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Special Offer Section */}
      <div className="special-offer">
        <div className="offer-content">
          <div className="offer-text">
            <h2>Summer Mega Sale!</h2>
            <p>Get up to 50% off on selected items. Limited time only!</p>
            <button className="offer-btn">View Deals</button>
          </div>
          <div className="discount-circle">
            <div className="discount">50%</div>
            <div className="discount-text">OFF</div>
          </div>
        </div>
      </div>

      {/* Back to Study Button */}
      <div style={{ padding: '60px 40px', textAlign: 'center', background: '#f9fafb' }}>
        <button 
          onClick={handleBackToSession}
          style={{
            background: '#001f3f',
            color: 'white',
            border: 'none',
            padding: '16px 40px',
            fontSize: '1.1rem',
            fontWeight: '600',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.3s'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-3px)';
            e.target.style.boxShadow = '0 8px 20px rgba(0, 31, 63, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          ← Back to Study Session
        </button>
      </div>
    </div>
  );
}

export default EcommerceLanding;
